import { useState } from 'react';
import { useQuery } from '../../_commons/query';

export function usePropertyData({
  prePopulation,
  integrationSettings,
  property,
  meta,
  pageContext,
  initialData,
  active = true,
  getProperties
}) {
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const getData = () => {
    let dataPromise;
    if (isFirstLoad && initialData) {
      dataPromise = Promise.resolve(initialData);
    } else {
      dataPromise = getProperties(
        {
          ...prePopulation.location,
          language: prePopulation.autoSettings?.language
        },
        integrationSettings,
        meta,
        pageContext
      );
    }

    return dataPromise
      .then((data) => {
        setIsFirstLoad(false);
        return data;
      })
      .catch((err) => {
        setIsFirstLoad(false);
        throw err;
      });
  };

  return useQuery({ getData, active }, [integrationSettings, property, meta]);
}

export function useProperty({ dispatch, value, filter }) {
  const properties = usePropertyData(filter);

  const clearProperty = () => {
    dispatch({ type: 'PROPERTY_CLEAR' });
  };

  const selectProperty = (newProperty) => {
    dispatch({ type: 'PROPERTY_CHANGE', payload: newProperty });
  };

  // [values, config]
  return {
    ...properties,
    property: value,
    onChange: selectProperty,
    onClear: clearProperty
  };
}
